import React, { Component } from "react";
import "../styles/App.css";
import axios from "axios";

// Import headers array and Header module
import headers from "./headers";

// Import genres array
import genres from "./genres";

// Import parameters array and Parameter module
import parameters from "./parameters";

// Import login page, navigation and content page
import LoginPage from './LoginPage';
import MainNav from './MainNav';
import Content from './Content';

// Import FontAwesome icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faPlay, faPause, faBan, faTimes, faInfoCircle, faPlus, faChevronDown } from '@fortawesome/free-solid-svg-icons';

// Add FontAwesome icons to library
library.add(fab, faPlay, faPause, faBan, faTimes, faInfoCircle, faPlus, faChevronDown);

// MAIN APP SECTION
class App extends Component {
  constructor() {
    super();
    this.state = {
      access_token: "", // String to store access token for Spotify API connection
      refresh_token: "", // String to store refresh token for Spotify API connection
      userInfo: null, // Object to store user info (if authorized)
      guest: false, // Boolean to determine whether user is a guest
      headers: headers, // Array with all header options
      headersUsed: [], // Array with all previously displayed header options
      currentTitle: headers[Math.floor(Math.random() * headers.length)], // Initial header string, set to first value in array
      searchTerm: "", // Initial value of search term
      showSearch: true, // Boolean to determine whether or not to show ul of song search
      genres: genres, // Array with all genre options
      showGenres: false, // Boolean to determine whether or not to show ul of all genres
      selectedGenre: "", // Set initial value of selectedGenre
      genreSearchTerm: genres[0].code, // Sets initial genre to first value in array
      showMainPage: true, // Boolean to determine whether or not to show main page
      showParams: false, // Boolean to determine whether or not to show parameter selection section
      parameters: parameters, // Array with parameters to map to page
      checkedParams: [], // Store which params are checked
      showRec: false, // Boolean to determine whether or not to show recommendation section
      showAutofill: false, // Boolean to determine whether or not to show song autofill ul
      autofillSongs: [], // Array to store songs that are currently being searched by user
      userSongId: "", // String to store ID of user song
      userSong: null, // Object to store data/metrics for user's selected song
      randomPlaylistId: "", // String to store ID of random playlist used for recommendation
      songChoices: [], // Array to store playlist containing potential recommended song choices
      comparisonSongId: "", // String to store ID of currently compared song
      comparisonSong: {}, // Object to store data/metrics for currently compared song
      recommendedSongId: "", // String to store ID of recommended song
      recommendedSong: {}, // Object to store data/metrics for recommended song
      songHistory: [], // Array to store last 10 recommended songs
      userSongPaused: true, // Boolean to determine whether user song is paused or playing
      recommendedSongPaused: true, // Boolean to determine whether recommended song is paused or playing
      showComparison: false, // Boolean to determine whether comparison modal is shown
      showHistory: false, // Boolean to determine whether history modal is shown
      showInfo: false, // Boolean to determine whether info modal is shown
    };
  }

  // METHOD TO GET NEW ACCESS TOKEN
  getToken = () => {
    // If authorization code flow is being used (user has authenticated and received refresh token):
    if (this.state.refresh_token) {
      return new Promise((resolve, reject) => {
        // Make call to the '/refresh' endpoint, passing through the refresh token
        axios
          .get("https://genrebenderapp.herokuapp.com/refresh", {
            params: {
              // Use the refresh_token we got on load.
              refresh_token: this.state.refresh_token
            }
          })
          .then(res => {
            // Grab the new token and return it
            const { access_token } = res.data;
            this.setState({
              access_token: access_token
            })
            resolve(access_token);
          });
      });
      // If client credentials flow is being used (no user auth):
    } else {
      return new Promise((resolve, reject) => {
        // Make call to the '/guestrefresh' endpoint, which will automatically pass client secret and ID from backend
        axios
          .get("https://genrebenderapp.herokuapp.com/guestrefresh")
          .then(res => {
            // Grab the new access token and return it
            const { access_token } = res.data;
            this.setState({
              access_token: access_token
            })
            resolve(access_token);
          });
      });
    }
  };

  // METHOD TO GET USER'S INFO
  getUserStatus = () => {
    // Make call to Spotify API to get user's data
      if (this.state.refresh_token) {
        axios
          .get("https://api.spotify.com/v1/me", {
            headers: {
              Authorization: `Bearer ${this.state.access_token}`
            }
          })
          .then(res => {
            // Store returned user data in object and update state
            const data = res.data;
            const user = {
              name: data.display_name,
              url: data.external_urls.spotify,
              imgURL: data.images[0].url
            }
            this.setState({ userInfo: user })

          }).catch(error => {
            if (error.response.status === 401) {
              console.log(error.response)
              // Alert the user to try again
              alert("Sorry, something went wrong. Please try again.");
              this.handleReset();
              this.setState({
                showMainPage: true, showRec: false
              });
            }
          });
      } else {
        console.log("No refresh token", this.state.refresh_token);
      }
  };

  // METHOD TO UPDATE HEADER MESSAGE ON CLICK OF HEADER TEXT ELEMENT
  updateHeader = () => {
    // Make a copy of headers in state and of array storing used headers
    const headersCopy = this.state.headers;
    const usedHeaders = this.state.headersUsed;
    // Check whether headers array length is greater than 1, if yes:
    if (this.state.headers.length > 1) {
      // Find a random index based off of array length
      const randomIndex = Math.floor(Math.random() * this.state.headers.length);
      // Set title to value at this index
      const title = this.state.headers[randomIndex];
      // Splice this index from headersCopy array and push into usedHeaders array (to avoid duplicates)
      usedHeaders.push(headersCopy.splice(randomIndex, 1));
      // Set state of current title, updated header array and updated used header array
      this.setState({
        currentTitle: title,
        headers: headersCopy,
        headersUsed: usedHeaders
      });
      // If array length is equal to 1, i.e. one value left in array, then:
    } else {
      // Set title to value at index 0
      const title = headersCopy[0];
      // Push final value to used headers array
      usedHeaders.push(headersCopy.splice(0, 1));
      // Set state of used headers to this array and update current title
      this.setState({
        currentTitle: title,
        headersUsed: usedHeaders
      }, () => {
        // Once used header array state has been set, then re-initialize both arrays to their respective values
        this.setState({
          headers: this.state.headersUsed,
          headersUsed: []
        })
      })
    }
  };

  // METHOD TO CLOSE AUTOFILL/GENRES ON CLICK OF BODY
  closeOnBodyClick = e => {
    // On click anywhere in app, check if autofill is showing; if yes, set to false to close
    if (this.state.showAutofill === true) {
      this.setState({
        showAutofill: false,
      })
    // On click anywhere in app, check if genres are showing; if yes, set to false to close
    } else if (this.state.showGenres === true) {
      this.setState({
        showGenres: false,
      })
    }
  }

  // METHOD TO AUTOFILL SONGS ON SEARCH USING CALL TO SPOTIFY API
  songAutofill = e => {
    // Set state of searchTerm to value of input and re-initialize autofill song array, user song ID and user song
    this.setState({ searchTerm: e.target.value, autofillSongs: [], userSong: null, userSongId: "" });
    // Check to make sure search term is not an empty string or undefined, if not:
    if (this.state.searchTerm !== "" && this.state.searchTerm !== undefined) {
      // Make call to Spotify API search endpoint
      axios
        .get("https://api.spotify.com/v1/search", {
          params: {
            q: this.state.searchTerm, // Use input (i.e. what user types into input field) as search query
            type: "track", // Only return tracks
            limit: 5 // Only return first 5 results
          },
          headers: {
            Authorization: `Bearer ${this.state.access_token}` // Use access token for authorization
          }
        })
        .then(res => {
          // Initialize an empty array to store autofill songs returned from Spotify API
          const autofillArray = [];
          // Go through each of the returned tracks in the data set
          res.data.tracks.items.forEach(track => {
            // Go through all artists (in case there is more than one) and push their names into an array
            const artistNames = [];
            track.artists.forEach(artist => artistNames.push(artist.name));
            // Store all data for the track in an object
            const trackItem = {
              songId: track.id,
              songName: track.name,
              albumName: track.album.name,
              albumYear: track.album.release_date.substring(0, 4),
              albumImg: track.album.images[0].url,
              artistNames: artistNames,
              previewURL: track.preview_url,
              externalURL: track.external_urls.spotify
            };
            // Push each track item object into the autofill array
            autofillArray.push(trackItem);
          });
          // Once the array has been populated, set it to state and change "showAutofill" boolean to true so the ul containing the songs displays
          if (autofillArray.length === res.data.tracks.items.length) {
            this.setState({
              autofillSongs: autofillArray,
              showAutofill: true
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            // If the API call returns an error with a code of 401 (meaning user is unauthorized)
            if (error.response.status === 401) {
              // Get a new token
              this.getToken();
              // Alert the user to try again
              alert("Sorry, something went wrong. Please try again.");
              this.handleReset();
              this.setState({
                showMainPage: true, showRec: false
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // Alert the user to try again
            alert("Sorry, something went wrong. Please try again.");
            this.handleReset();
            this.setState({
              showMainPage: true, showRec: false
            });
            console.log(error.request);
          } else {
            // Alert the user to try again
            alert("Sorry, something went wrong. Please try again.");
            this.handleReset();
            this.setState({
              showMainPage: true, showRec: false
            });
            console.log(error.message);
          }
        });
    }
  };

  // METHOD TO UPDATE SEARCH TERM WHEN USER CLICKS ON ONE OF THE AUTOFILL OPTIONS
  updateSearch = e => {
    // Set state of search term to text content (to show term in input), store user song ID from clicked li, and set state of autofill display to false to hide ul
    this.setState({
      searchTerm: e.target.textContent,
      userSongId: e.target.id,
      showAutofill: false
    });
  };

  // METHOD TO UPDATE GENRE WHEN USER CLICKS ON ONE OF THE LIST ITEMS
  updateGenre = e => {
    // Set state of selected genre to text content (to show genre in input), store genre from clicked li, and set state of genre list display to false to hide ul
    this.setState({
      selectedGenre: e.target.textContent,
      genreSearchTerm: e.target.id,
      showGenres: false
    });
  };

  // METHOD TO HANDLE TOGGLING OF SECTION WITH PARAMETERS/GENRES
  handleToggleClick = e => {
    e.preventDefault();
    // Set state of clicked button/input id to opposite of current boolean value
    // This method is used on "showGenres" and "showParams" to change their visibility
    this.setState({ [e.target.id]: !this.state[e.target.id] });
  };

  // METHOD TO UPDATE VALUE OF PARAMETERS IN STATE WHEN THEY ARE CHECKED OR UNCHECKED
  handleParamChange = e => {
    // Create array to store order in which parameters have been checked
    const storeCheckedOrder = this.state.checkedParams;

    // Initialize a variable to store parameter to remove
    let paramToRemove = null;

    // Check if array has 2 items, if yes, remove the last one and store in parameter variable
    if (storeCheckedOrder.length > 1) {
      paramToRemove = storeCheckedOrder.pop();
    }

    // Create duplicate of parameters array from state
    const updatedParameters = Array.from(this.state.parameters);

    // Find index of selected parameter in parameters array in state
    const matchingIndex = updatedParameters.findIndex(object => {
      return object.id === e.target.id;
    });

    // If there is a parameter to be removed, find its index in state and change its checked value
    if (paramToRemove) { 
      const removedIndex = updatedParameters.findIndex(object => {
        return object.id === paramToRemove.id;
      })

      updatedParameters[removedIndex].checked = !updatedParameters[removedIndex]
        .checked;
    }

    // Change "checked" (boolean) value of the selected parameter in duplicate array to its opposite
    updatedParameters[matchingIndex].checked = !updatedParameters[matchingIndex]
      .checked;

    // Add object at matching index (newly checked parameter) to storeCheckedOrder array
    storeCheckedOrder.unshift(updatedParameters[matchingIndex]);

    // Update parameters arrays in state to changed duplicates
    this.setState({
      parameters: updatedParameters,
      checkedParams: storeCheckedOrder
    });
  };

  // METHOD TO RANDOMLY SELECT SONG AND GENRE
  randomizeSelection = e => {
    e.preventDefault();
    // Create an array containing all alphabet letters
    const alphabetArray = [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ];
    // Pull a random letter from the alphabet array
    const randomLetter = alphabetArray[Math.floor(Math.random() * alphabetArray.length)];
    // Make a call to the Spotify API search endpoint
    axios
      .get("https://api.spotify.com/v1/search", {
        params: {
          q: randomLetter, // Use random letter as search query
          type: "track", // Only return track
          limit: 1, // Only return 1 song
          offset: Math.floor(Math.random() * 500) // Randomize offset up to 500
        },
        headers: {
          Authorization: `Bearer ${this.state.access_token}`
        }
      })
      .then(res => {
        // Store returned track data
        const track = res.data.tracks.items[0];
        // Go through all artists (in case there is more than one) and push their names into an array
        const artistNames = [];
        track.artists.forEach(artist => artistNames.push(artist.name));
        // Store all data for the track in an object
        const trackItem = {
          songId: track.id,
          songName: track.name,
          albumName: track.album.name,
          albumYear: track.album.release_date.substring(0, 4),
          albumImg: track.album.images[0].url,
          artistNames: artistNames,
          previewURL: track.preview_url,
          externalURL: track.external_urls.spotify
        };
        // Update search term to include song data
        const term = `${trackItem.songName} by ${trackItem.artistNames[0]} ${
          trackItem.albumName
          } (${trackItem.albumYear})`;
        // Update user song in state to match data of random song and update search term to show random song information in input
        this.setState({
          userSongId: trackItem.songId,
          userSong: trackItem,
          searchTerm: term
        });
      })
      .then(() => {
        // Pull a random index from length of genres array
        const randomIndex = Math.floor(
          Math.random() * this.state.genres.length
        );
        // Set state of genre to matching genre at random index
        const genre = this.state.genres[randomIndex].name;
        this.setState({ selectedGenre: genre });
      }).catch(error => {
        if (error.response) {
          // If the API call returns an error with a code of 401 (meaning user is unauthorized)
          if (error.response.status === 401) {
            // Get a new token
            this.getToken();
            // Alert the user to try again
            alert("Sorry, something went wrong. Please try again.");
            this.handleReset();
            this.setState({
              showMainPage: true, showRec: false
            });
          }
        } else if (error.request) {
          // The request was made but no response was received
          // Alert the user to try again
          alert("Sorry, something went wrong. Please try again.");
          this.handleReset();
          this.setState({
            showMainPage: true, showRec: false
          });
          console.log(error.request);
        } else {
          // Alert the user to try again
          alert("Sorry, something went wrong. Please try again.");
          this.handleReset();
          this.setState({
            showMainPage: true, showRec: false
          });
          console.log(error.message);
        }
      });
  };

  // METHOD TO CHECK IF A SONG ALREADY EXISTS IN USER'S LIBRARY
  checkLibrary = (songId) => {
      // Make call to Spotify API to check whether track exists in user's library, passing in the clicked ID from state
      axios.get("https://api.spotify.com/v1/me/tracks/contains", {
        params: {
          ids: this.state[songId]
        },
        headers: {
          Authorization: `Bearer ${this.state.access_token}`,
          // 'Content-Type': 'application/json'
        }
      }).then(res => {
        // Based on whether library check returns false, i.e. song is not in user's library
        if (res.data[0] === false) {
          // Make put request to place song with current song ID to user's library
          axios.put("https://api.spotify.com/v1/me/tracks", {}, {
            headers: {
              Authorization: `Bearer ${this.state.access_token}`
            },
            params: {
              ids: this.state[songId]
            },
          }).then(res => {
            // Remove "Id" string from song ID variable to target entire song object
            const song = songId.substring(0, songId.length - 2);
            // Alert user that song has been placed in library with relevant song's name and user's display name
            alert(`'${this.state[song].songName}' has been successfully saved to your library, ${this.state.userInfo.name}.`)
          }).catch(error => {
            // If there is any error saving song, let user know and prompt them to try again
            if (error.response) {
              console.log(error.response);
              alert("Sorry, there was an error saving your song. Please try again.")
            } else {
              console.log(error);
            }
          })
        // If library check returns true, i.e. song IS in user's library, alert them and take no further action
        } else {
          alert("This song is already in your library.");
        }
      }).catch(error => {
        console.log(error);
      })
  }

  // METHOD TO SAVE SONG TO USER'S LIBRARY
  saveSong = (e) => {
    // Check if user is logged in, if not, prompt them to log in
    if (!this.state.userInfo) {
      alert("Error: You must be logged in to Spotify to use this feature.");
      return;
    // If user is logged in, run id of selected button (either "userSongId" or "recommendedSongId") through checkLibrary function
    } else {
      this.checkLibrary(e.target.id);
    }
  }

  // METHOD TO TAKE INPUTS AND START RECOMMENDATION
  handleRecommendation = e => {
    // If there is a default event, prevent it (this will trigger on click of "Recommend" but not "Try another")
    if (e) {
      e.preventDefault();
    }
    // If there is no user song, then:
    if (this.state.userSong === null) {
      // Find the object containing the clicked song ID from autofill array and update user song object in state
      const selectedSong = this.state.autofillSongs.filter(song => {
        return song.songId === this.state.userSongId;
      });
      this.setState({ userSong: selectedSong[0] });
    }
    // Make call to Spotify API to get audio features of song
    axios
      .get(
        `https://api.spotify.com/v1/audio-features/${this.state.userSongId}`,
        {
          headers: {
            Authorization: `Bearer ${this.state.access_token}`
          }
        }
      )
      .then(res => {
        // Add features to userSong and store in new object
        const updatedSong = Object.assign(
          {
            features: {
              danceability: res.data.danceability,
              duration: res.data.duration_ms,
              energy: res.data.energy,
              key: res.data.key,
              mode: res.data.mode,
              tempo: res.data.tempo,
              valence: res.data.valence
            }
          },
          this.state.userSong
        );
        // Set state of user song to updated song object
        this.setState({ userSong: updatedSong });
      }).catch(error => {
        if (error.response) {
          // If the API call returns an error with a code of 401 (meaning user is unauthorized)
          if (error.response.status === 401) {
            // Get a new token
            this.getToken();
            // Alert the user to try again
            alert("Sorry, something went wrong. Please try again.");
            this.handleReset();
            this.setState({
              showMainPage: true, showRec: false
            });
          }
        } else if (error.request) {
          // The request was made but no response was received
          // Alert the user to try again
          alert("Sorry, something went wrong. Please try again.");
          this.handleReset();
          this.setState({
            showMainPage: true, showRec: false
          });
          console.log(error.request);
        } else {
          // Alert the user to try again
          alert("Sorry, something went wrong. Please try again.");
          this.handleReset();
          this.setState({
            showMainPage: true, showRec: false
          });
          console.log(error.message);
        }
      });
    // Make second call to Spotify API search endpoint
    axios
      .get(`https://api.spotify.com/v1/search`, {
        params: {
          q: this.state.selectedGenre, // Use selected genre as search query
          type: "playlist", // Only return playlists
          limit: 1, // Only return 1 playlist
          offset: Math.floor(Math.random() * 500) // Randomize offset up to 500
        },
        headers: {
          Authorization: `Bearer ${this.state.access_token}`
        }
      })
      .then(res => {
        // Set playlist ID to state
        this.setState({ randomPlaylistId: res.data.playlists.items[0].id });
      }).then(() => {
        // Call function to get tracks of recommended playlist
        this.getRecommendedPlaylist();
      }).catch(error => {
        if (error.response) {
          // If the API call returns an error with a code of 401 (meaning user is unauthorized)
          if (error.response.status === 401) {
            // Get a new token
            this.getToken();
            // Alert the user to try again
            alert("Sorry, something went wrong. Please try again.");
            this.setState({
              showMainPage: true, showRec: false
            });
          }
        } else if (error.request) {
          // The request was made but no response was received
          // Alert the user to try again
          alert("Sorry, something went wrong. Please try again.");
          this.handleReset();
          this.setState({
            showMainPage: true, showRec: false
          });
          console.log(error.request);
        } else {
          // Alert the user to try again
          alert("Sorry, something went wrong. Please try again.");
          this.handleReset();
          this.setState({
            showMainPage: true, showRec: false
          });
          console.log(error.message);
        }
      });
  };

  // Method to run comparison of two songs
  runComparison = () => {
    // Function to compare integer values that takes in user song value and recommended song value
    const compareMatch = (userVar, recVar) => {
      // Check if integers are within 25% of each other; if yes, return true; if no, return false
      if ((0.75 < (userVar / recVar)) && ((userVar / recVar) < 1.25)) {
        return true;
      } else {
        return false;
      }
    }

    // Function to compare key and mode values
    const compareKeyMode = () => {
      // Check if key and mode are exact match and return true/false accordingly
      if ((this.state.userSong.features.key === this.state.comparisonSong.features.key) && (this.state.userSong.features.mode === this.state.comparisonSong.features.mode)) {
        return true;
      } else {
        return false;
      }
    }

    // Function to compare decimal values that takes in user song value and recommended song value
    const compareDecimals = (userVar, recVar) => {
      // Check if absolute value of the difference between the two variables is within 0.25 aka 25% and return true/false accordingly
      if (Math.abs(userVar - recVar) < 0.25) {
        return true;
      } else {
        return false;
      }
    }

    // Make temporary array of parameters to compare
    const parametersToCompare = this.state.checkedParams;

    // Make variable to store user song features and rec song features from state
    const userSongFeatures = this.state.userSong.features;
    const comparisonSongFeatures = this.state.comparisonSong.features;
    
    // Initialize empty array for comparison songs
    const comparisonArray = [];

    // Map through checked parameters, for each pass through appropriate function to compare values and push boolean result to comparison array
    parametersToCompare.forEach(parameter => {
      if (parameter.id === 'duration' || parameter.id === 'tempo') {
        comparisonArray.push(compareMatch(userSongFeatures[parameter.id], comparisonSongFeatures[parameter.id]));
      } else if (parameter.id === 'danceability' || parameter.id === 'energy' || parameter.id === 'valence') {
        comparisonArray.push(compareDecimals(userSongFeatures[parameter.id], comparisonSongFeatures[parameter.id]));
      } else {
        comparisonArray.push(compareKeyMode());
      }
    });

    // Go through entire array and if any of the match values is false, set song match variable to false and break out of loop
    let doSongsMatch = true;
    for (let i=0; i < comparisonArray.length; i++) {
      if (comparisonArray[i] === false) {
        doSongsMatch = false;
        break;
      }
    }
    return doSongsMatch;
  }

  // METHOD TO GET PLAYLIST FROM WHICH TO PULL RECOMMENDATIONS
  getRecommendedPlaylist = () => {
    // Make call to Spotify API to get tracks from recommended playlist
    axios
      .get(
        `https://api.spotify.com/v1/playlists/${
        this.state.randomPlaylistId
        }/tracks`,
        {
          params: {
            limit: 100 // Only return 50 songs
          },
          headers: {
            Authorization: `Bearer ${this.state.access_token}`
          }
        }
      )
      .then(res => {
        // Set returned tracks to array in state
        const trackOptions = res.data.items;
        this.setState({
          songChoices: trackOptions
        });
        // Call function to get recommended song from playlist tracks
        this.getRecommendedSong();
      }).catch(error => {
        console.log(error);
        alert("Sorry, something went wrong. Please try again.");
        this.setState({
          showMainPage: true, showRec: false
        });
      });
  };

  // METHOD TO RUN FUNCTION TO RETURN RECOMMENDED SONG
  getRecommendedSong = () => {
    // Re-initialize all keys/values of recommended song object and update state
    const resetTrack = {
      songId: '',
      songName: '',
      albumName: '',
      albumYear: '',
      albumImg: '',
      artistNames: [],
      previewURL: '',
      externalURL: ''
    };
    this.setState({
      // recommendedSong: resetTrack,
      comparisonSong: resetTrack
    });
    // Get random index based on length of song choices array
    const randomIndex = Math.floor(
      Math.random() * (this.state.songChoices.length - 1)
    );
    // Get track at random index and remove from song choice array
    const track = this.state.songChoices[randomIndex].track;
    this.state.songChoices.splice(randomIndex, 1);

    // Make array to store artist names
    const artistNames = [];
    track.artists.forEach(artist => artistNames.push(artist.name));
    // Store all data for the track in an object and update recommended song in state
    const trackItem = {
      songId: track.id,
      songName: track.name,
      albumName: track.album.name,
      albumYear: track.album.release_date.substring(0, 4),
      albumImg: track.album.images[0].url,
      artistNames: artistNames,
      previewURL: track.preview_url,
      externalURL: track.external_urls.spotify
    };
    this.setState({
      comparisonSongId: track.id,
      comparisonSong: trackItem,
      // recommendedSongId: track.id,
      // recommendedSong: trackItem
    });

    // Make call to Spotify API to get audio features of recommended song
    axios
      .get(
        `https://api.spotify.com/v1/audio-features/${
        this.state.comparisonSongId
        }`,
        {
          headers: {
            Authorization: `Bearer ${this.state.access_token}`
          }
        }
      )
      .then(res => {
        // Add features to recommendedSong and store in new object
        const newRecSong = Object.assign(
          {
            features: {
              danceability: res.data.danceability,
              duration: res.data.duration_ms,
              energy: res.data.energy,
              key: res.data.key,
              mode: res.data.mode,
              tempo: res.data.tempo,
              valence: res.data.valence
            }
          },
          this.state.comparisonSong
        );
        // Update state of recommended song and then navigate to recommendation page
        this.setState({ comparisonSong: newRecSong }, () => {
          const songMatch = this.runComparison();
          if (songMatch === false) {
            this.getRecommendedSong();
          } else {
            this.setState({ recommendedSong: this.state.comparisonSong}, () => {
              // Copy song history array from state
              const newSongHistory = this.state.songHistory;
              // Check if array has 10 items, if yes, remove last item
              if (newSongHistory.length === 10) {
                newSongHistory.splice(-1);
              }
              // Add current recommended song to start of array and update state
              newSongHistory.unshift(this.state.recommendedSong);
              this.setState({
                songHistory: newSongHistory
              });

              this.setState({
                showMainPage: false, showRec: true 
              })
            });
          }
        });
      }).catch(error => {
        if (error.response) {
          // If the API call returns an error with a code of 401 (meaning user is unauthorized)
          if (error.response.status === 401) {
            // Get a new token
            this.getToken();
            // Alert the user to try again
            alert("Sorry, something went wrong. Please try again.");
            this.handleReset();
            this.setState({
              showMainPage: true, showRec: false
            });
          }
        } else if (error.request) {
          // The request was made but no response was received
          // Alert the user to try again
          alert("Sorry, something went wrong. Please try again.");
          this.handleReset();
          this.setState({
            showMainPage: true, showRec: false
          });
          console.log(error.request);
        } else {
          // Alert the user to try again
          alert("Sorry, something went wrong. Please try again.");
          this.handleReset();
          this.setState({
            showMainPage: true, showRec: false
          });
          console.log(error.message);
        }
      });
  };


  // METHOD TO TRY ANOTHER SONG WITH SAME PARAMETERS
  tryAnother = () => {
    // Handling to stop playing if recommended song is currently playing (when function runs from "try another" click)
    // Check if there is a recommended song, if yes:
    if (this.state.recommendedSong.previewURL) {
      // Get recommended song audio element, pause and update state to change icon
      const recAudioElement = document.getElementById('recommendedSongAudio');
      recAudioElement.pause();
      this.setState({
        recommendedSongPaused: true,
      })
    }
    // Rerun function to handle recommendation
    this.handleRecommendation();
  }


  // METHOD TO CHANGE ACTIVE SONG USING SONG HISTORY LIST
  changeActiveSong = (e) => {
    // If there is a recommended song:
    if (this.state.recommendedSong.previewURL) {
      // Get recommended song audio element, pause and update state to change icon
      const recAudioElement = document.getElementById('recommendedSongAudio');
      recAudioElement.pause();
      this.setState({
        recommendedSongPaused: true,
      })
    }
    // On click of song in history modal, map through song history array, find song with ID that matches target ID, update recommended song and change showHistory boolean to hide modal
    e.target.id && this.state.songHistory.forEach((song, i) => {
      song.songId === e.target.id && this.setState({
        recommendedSongId: e.target.id,
        recommendedSong: this.state.songHistory[i],
        showHistory: false,
      })
    })
  }

  // METHOD TO SHOW ANY MODAL ON CLICK
  showModal = e => {
    e.preventDefault();
    // Set state of id ("showHistory", "showComparison") to opposite of current boolean value
    this.setState({
      [e.target.id]: !this.state[e.target.id]
    })
  }

  // METHOD TO PLAY AUDIO ON CLICK
  playAudio = e => {
    // Get audio element corresponding to the id of button that has been clicked and store in variable -- no need for error handling, empty preview URL disables button by default
    const clickedElementId = e.target.id;
    const clickedElement = document.getElementById(`${clickedElementId}Audio`);

    // Check what alternate audio element is and store in another separate variable; if none, leave as null
    let alternateElement;
    let alternateElementId;
    if (e.target.id === "recommendedSong" && this.state.userSong.previewURL) {
      alternateElement = document.getElementById('userSongAudio');
      alternateElementId = 'userSong';
    } else if (e.target.id === "userSong" && this.state.recommendedSong.previewURL) {
      alternateElement = document.getElementById('recommendedSongAudio');
      alternateElementId = 'recommendedSong';
    } else {
      alternateElement = null;
    }

    // Check if clicked element is paused, if yes and other element exists and is playing, pause it and update state
    if (clickedElement.paused && alternateElement && !alternateElement.paused) {
      alternateElement.pause();
      clickedElement.play();
      this.setState({
        [`${clickedElementId}Paused`]: false,
        [`${alternateElementId}Paused`]: true
      });
      // If element is paused, and other element doesn't exist or exists but isn't playing, play clicked element and update state
    } else if (clickedElement.paused || (clickedElement.paused && alternateElement)) {
      clickedElement.play();
      this.setState({
        [`${clickedElementId}Paused`]: false,
      });
      // If element is playing, pause it and update state
    } else if (!clickedElement.paused) {
      clickedElement.pause();
      this.setState({
        [`${clickedElementId}Paused`]: true,
      });
    }
  }

  // METHOD TO HANDLE END OF AUDIO PLAYING
  handlePlaybackEnd = (e) => {
    // Get ID of element that has finished playing
    const endedElementId = e.target.id;
    // Remove "Audio" from ID string
    const song = endedElementId.replace("Audio", '');
    // Update paused state of ended element
    this.setState({
      [`${song}Paused`]: true,
    })
  }

  // METHOD TO RESET ALL VARIABLES
  handleReset = () => {
    // Create copy of parameters array
    const params = this.state.parameters;
    // Go through each item in array and if checked value is false, change to true
    params.forEach(parameter => {
      if (parameter.checked === true) {
        parameter.checked = false;
      }
    });

    // Update state to match initial values
    this.setState({
      autofillSongs: [],
      genreSearchTerm: genres[0].code,
      randomPlaylistId: "",
      recommendedSong: {},
      recommendedSongId: "",
      comparisonSong: {},
      comparisonSongId: "",
      searchTerm: "",
      selectedGenre: "",
      userSong: null,
      userSongId: "",
      showMainPage: true,
      showRec: false,
      songChoices: [],
      songHistory: [],
      showParams: false,
      parameters: params,
      checkedParams: [],
    });
  };

  // COMPONENT DID MOUNT
  componentDidMount() {
    // Check if there is an access token/refresh token in URL, if yes, update state to match token strings from URL
    const getAllTokens = new Promise((resolve, reject) => {
      const loc = window.location;
      if (loc.search !== "") {
        const url = new URL(loc.href);
        this.setState({
          access_token: url.searchParams.get("access_token"),
          refresh_token: url.searchParams.get("refresh_token")
        });
      }
      resolve('Mounted');
    });

    // Once component has mounted and tokens hae been retrieved from URL, get user status to determine whether user is guest or authorized and display info
    getAllTokens.then(() => {
      this.getUserStatus();
    })
  }

  // RENDER
  render() {
    return (
      <div className="App" onClick={this.closeOnBodyClick}>
        <div>
          {/* Conditional rendering of main navigation depending on existence of access token (i.e. user has logged in or continued as guest) */}
          {this.state.access_token && <MainNav userInfo={this.state.userInfo} refresh_token={this.state.refresh_token} handleReset=
          {this.handleReset} showInfo={this.state.showInfo} showModal={this.showModal}/>}
          <div className="Wrapper">
            <div className="flexContainer">
              {/* Conditional rendering of either main content or login page depending on existence of access token (i.e. user has logged in or continued as guest) */}
              {this.state.access_token ? <div>
                <Content userInfo={this.state.userInfo} currentTitle={this.state.currentTitle}
                  updateHeader={this.updateHeader}
                  searchTerm={this.state.searchTerm}
                  updateSearch={this.updateSearch}
                  genres={this.state.genres}
                  selectedGenre={this.state.selectedGenre}
                  key={this.state.genres.code}
                  updateGenre={this.updateGenre}
                  handleToggleClick={this.handleToggleClick}
                  showGenres={this.state.showGenres}
                  songAutofill={this.songAutofill}
                  showAutofill={this.state.showAutofill}
                  autofillSongs={this.state.autofillSongs}
                  userSongId={this.state.userSongId}
                  handleRecommendation={this.handleRecommendation}
                  handleParamChange={this.handleParamChange}
                  parameters={this.state.parameters}
                  showParams={this.state.showParams}
                  randomizeSelection={this.randomizeSelection}
                  showModal={this.showModal}
                  songHistory={this.state.songHistory}
                  changeActiveSong={this.changeActiveSong}
                  recommendedSongId={this.state.recommendedSongId}
                  showHistory={this.state.showHistory}
                  showComparison={this.state.showComparison}
                  showInfo={this.state.showInfo}
                  showRec={this.state.showRec}
                  userSong={this.state.userSong}
                  recommendedSong={this.state.recommendedSong}
                  handleReset={this.handleReset}
                  recommendedSongPaused={this.state.recommendedSongPaused}
                  userSongPaused={this.state.userSongPaused}
                  playAudio={this.playAudio}
                  tryAnother={this.tryAnother}
                  saveSong={this.saveSong}
                  checkLibrary={this.checkLibrary}
                  handlePlaybackEnd={this.handlePlaybackEnd} /></div> : <LoginPage showInfo={this.state.showInfo} showModal={this.showModal}/>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
